module.exports = __webpack_public_path__ + "img/kootto_private_chef_plate_900.e78c90b8.webp";